import React, { Component } from 'react';
import './sidebar-rounded-icons.css';

export default class SidebarRoundedIcons extends Component {
  constructor(props) {
    super(props);

    this.state = {
      "color": "#FFF"
    }
  }

  componentWillMount() {

  }

  redirectTo(path) {
    window.location = window.location.origin + window.location.pathname + "#" + path;
  }

  isActive(path) {
    const currentHash = window.location.hash.replace('#', '');
    if (path === '' && (currentHash === '' || currentHash === '/')) {
      return true;
    }
    return currentHash === path;
  }

  render() {
    return (
      <ul className="rdp-react-template-component-sidebar-rounded-icons" role="navigation" aria-label="Navegação Principal">
        <li className={`rdp-react-template-component-sidebar-rounded-icons-item ${this.isActive('') ? 'active' : ''}`} onClick={() => this.redirectTo('')} role="button" tabIndex="0" aria-label="Início" onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            if (e.key === ' ') e.preventDefault();
            this.redirectTo('');
          }
        }}>
          <span className="rdp-react-template-component-sidebar-rounded-icons-item-icon home">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
              <path fill="#024980" d="M25.16,13.82L15.59,5.51c-.34-.29-.84-.29-1.18,0L4.84,13.83c-.37.32-.41.89-.09,1.26.17.19.41.31.67.31h2.37v8.41c0,.49.4.9.9.9h3.38c.49,0,.9-.4.9-.9,0,0,0,0,0,0v-5.93h3.95v5.93c0,.49.4.9.9.9h3.33c.49,0,.9-.4.9-.9,0,0,0,0,0,0v-8.41h2.53c.49,0,.9-.4.9-.9,0-.26-.11-.51-.31-.68ZM22.01,14.46c-.49,0-.9.4-.9.9v8.41h-3.26v-5.93c0-.5-.4-.9-.9-.9,0,0,0,0,0,0h-4.02c-.49,0-.9.4-.9.9v5.93h-3.3v-8.41c0-.49-.4-.9-.9-.9h-2.31L15,6.23l9.48,8.23h-2.47Z" />
            </svg>
          </span>
        </li>

        <li className={`rdp-react-template-component-sidebar-rounded-icons-item ${this.isActive('/library/bookmarks') ? 'active' : ''}`} onClick={() => this.redirectTo('/library/bookmarks')} role="button" tabIndex="0" aria-label="Favoritos" onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            if (e.key === ' ') e.preventDefault();
            this.redirectTo('/library/bookmarks');
          }
        }}>
          <span className="rdp-react-template-component-sidebar-rounded-icons-item-icon favoritos">
            <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M12 6.00019C10.2006 3.90317 7.19377 3.2551 4.93923 5.17534C2.68468 7.09558 2.36727 10.3061 4.13778 12.5772C5.60984 14.4654 10.0648 18.4479 11.5249 19.7369C11.6882 19.8811 11.7699 19.9532 11.8652 19.9815C11.9483 20.0062 12.0393 20.0062 12.1225 19.9815C12.2178 19.9532 12.2994 19.8811 12.4628 19.7369C13.9229 18.4479 18.3778 14.4654 19.8499 12.5772C21.6204 10.3061 21.3417 7.07538 19.0484 5.17534C16.7551 3.2753 13.7994 3.90317 12 6.00019Z" stroke="#024980" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
            </svg>

          </span>
        </li>

        <li className={`rdp-react-template-component-sidebar-rounded-icons-item ${this.isActive('/library/notes') ? 'active' : ''}`} onClick={() => this.redirectTo('/library/notes')} role="button" tabIndex="0" aria-label="Marcações" onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            if (e.key === ' ') e.preventDefault();
            this.redirectTo('/library/notes');
          }
        }}>
          <span className="rdp-react-template-component-sidebar-rounded-icons-item-icon marcadores">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="1 0 30 30">
              <path fill="#024980" d="M9.23,25.31c-.18,0-.35-.04-.51-.11-.43-.19-.7-.62-.7-1.09V5.88c0-.66.54-1.19,1.2-1.19h11.55c.66,0,1.2.53,1.2,1.19v18.23c0,.66-.54,1.2-1.21,1.2-.29,0-.57-.11-.79-.3h0l-4.77-4.19c-.11-.09-.26-.09-.37,0l-4.83,4.2c-.22.19-.5.3-.79.3ZM9.23,5.62c-.15,0-.27.11-.28.26,0,0,0,0,0,0v18.24c0,.1.06.19.16.23.1.05.22.04.31-.04l4.82-4.2c.46-.4,1.13-.4,1.59,0l4.77,4.19c.08.07.2.09.3.04.09-.04.16-.13.16-.23V5.88c0-.15-.12-.27-.27-.26h0s-11.55,0-11.55,0Z" />
            </svg>
          </span>
        </li>

        <li className={`rdp-react-template-component-sidebar-rounded-icons-item ${this.isActive('/library/readinglist') ? 'active' : ''}`} onClick={() => this.redirectTo('/library/readinglist')} role="button" tabIndex="0" aria-label="Listas de Leitura" onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            if (e.key === ' ') e.preventDefault();
            this.redirectTo('/library/readinglist');
          }
        }}>
          <span className="rdp-react-template-component-sidebar-rounded-icons-item-icon listas-de-leitura">
            <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28">
              <circle fill="#024980" cx="7.02" cy="13.92" r="1" />
              <circle fill="#024980" cx="7.02" cy="17.92" r="1" />
              <circle fill="#024980" cx="7.02" cy="21.92" r="1" />
              <path fill="#024980" d="M21.26,14.32h-11.74c-.22,0-.4-.18-.4-.4s.18-.4.4-.4h11.74c.22,0,.4.18.4.4s-.18.4-.4.4Z" />
              <circle fill="#024980" cx="7.02" cy="9.92" r="1" />
              <path fill="#024980" d="M21.26,10.32h-11.74c-.22,0-.4-.18-.4-.4s.18-.4.4-.4h11.74c.22,0,.4.18.4.4s-.18.4-.4.4Z" />
              <path fill="#024980" d="M21.26,18.32h-11.74c-.22,0-.4-.18-.4-.4s.18-.4.4-.4h11.74c.22,0,.4.18.4.4s-.18.4-.4.4Z" />
              <path fill="#024980" d="M21.26,22.32h-11.74c-.22,0-.4-.18-.4-.4s.18-.4.4-.4h11.74c.22,0,.4.18.4.4s-.18.4-.4.4Z" />
            </svg>
          </span>
        </li>










      </ul>
    );
  }
}